import { toast } from "../../components/AppToast";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import Stepper from "../../components/Stepper";
import { selfSignUp } from "../../services/auth/auth";
import { addressRequiredFields, adminSelfSignup, contactRequiredFields, SelfSignUpFields } from "../../utils/enumSelfSignup";
import AddressPage from "./AddressPage";
import ContactsPage from "./ContactsPage";
import Identification from "./IdentificationPage";
import PaymentPage from "./PaymentPage";
import SystemInfo from "./SystemInfo";
import WelcomePage from "./WelcomePage";
import { useNavigate } from "react-router-dom";

const SelfSignUp = () => {
    const navigate = useNavigate();
    const steps = [
        {
            title: 'Welcome',
            icon: HomeOutlinedIcon,
            content: ({ formData, setFormData }) => <WelcomePage dataFor={"tenant"} formData={formData} setFormData={setFormData} />,
            canProceed: (formData) => !!formData?.[SelfSignUpFields.TENANT_TYPE],
        },
        {
            title: 'Identification',
            icon: AssignmentIndOutlinedIcon,
            content: ({ formData, setFormData }) => <Identification formData={{...formData, tenant_regDetails: [ { file: "xyz", doc_type: "image", name: "gstFile" } ]}} setFormData={setFormData} />,
            canProceed: (formData) => !!formData?.[SelfSignUpFields.TENANT_NAME] && !!formData?.[SelfSignUpFields.INDUSTRY_TYPE]
        },
        {
            title: 'Address',
            icon: LocationOnOutlinedIcon,
            content: ({ formData, setFormData }) => <AddressPage dataFor={"tenant"} formData={formData} setFormData={setFormData} />,
            canProceed: (formData) => {
                const address = formData?.address || [];
                const formFilled = addressRequiredFields.every((field) => !!address?.[field]);
                return formFilled;
            }
        },
        {
            title: 'Contacts',
            icon: ContactMailOutlinedIcon,
            content: ({ formData, setFormData }) => <ContactsPage dataFor={"tenant"} formData={formData} setFormData={setFormData} />,
            canProceed: (formData) => {
                const contacts = formData?.contact || [];

                const hasAdmin = contacts.some(
                    (c) =>
                        c?.[adminSelfSignup.ADMIN_USER] === true &&
                        contactRequiredFields.every((field) => !!c?.[field])
                );
                return hasAdmin;
            }
        },
        {
            title: 'System Information',
            icon: SettingsOutlinedIcon,
            content: ({ formData, setFormData }) => <SystemInfo formData={formData} setFormData={setFormData} />,
            canProceed: (formData) => 
                !!formData?.[SelfSignUpFields.TENANT_SYSTEMCAPABILITIES] &&
                !!formData?.[SelfSignUpFields.TENANT_NUMOFUSERLIC]
        },
        {
            title: 'Payment & Submit',
            icon: CreditCardOutlinedIcon,
            content: ({ formData, setFormData }) => <PaymentPage formData={formData} setFormData={setFormData} />,
            canProceed: (formData) => !!formData?.[SelfSignUpFields.TENANT_TERMS_AND_CONDITIONS]
        },
    ];

    const onFinish = async (data) => {
        try {
            const updatedData ={...data, contact: data?.contact?.map(({ id, ...rest }) => rest)};

            console.log(updatedData);
            let tenantSystemCapabilities = [];
            updatedData.tenant_systemCapabilities.forEach((element,index) => {
                tenantSystemCapabilities.push({
                    capability : element,
                    enabled : true,
                    order : index +1
                })
            });

            updatedData.tenantSystemCapabilities = tenantSystemCapabilities;

            delete updatedData.tenant_systemCapabilities;
            
            console.log(updatedData);
            

            const message = await selfSignUp(updatedData);
            navigate("/login");
            toast.success(message);
        } catch (err) {
            toast.error(err);
        }
    }

    return (
        <>
            <Stepper steps={steps} onFinish={onFinish}/>
        </>
    )
}

export default SelfSignUp;